import React from 'react';
import { Avatar } from '@mui/material';
import useUserAvatar from '../hooks/useUserAvatar';

/**
 * Displays a user's profile picture from the avatar cache (downloads only on key change).
 * Falls back to initials when no avatar is set / available.
 */
export default function UserAvatar({
  user,
  size = 40,
  sx = {},
  className,
  ...avatarProps
}) {
  const { src } = useUserAvatar(user);
  const initials = `${user?.first_name?.charAt(0) || ''}${user?.last_name?.charAt(0) || ''}`;

  return (
    <Avatar
      className={className}
      src={src || undefined}
      alt={user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : undefined}
      sx={{
        width: size,
        height: size,
        fontSize: size <= 36 ? '0.875rem' : size <= 48 ? '1rem' : '1.25rem',
        flexShrink: 0,
        ...sx,
      }}
      {...avatarProps}
    >
      {!src && initials}
    </Avatar>
  );
}
